import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  GetArticleRecordByPage({}, params) {
    return new Promise((resolve, reject) => {
      get(`ugc/article_record/${params.item_id}/`, params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },
  GetNovelCredit({}, params) {
    return new Promise((resolve, reject) => {
      get(`credit/novel/get/`, params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetUgcItem({}, params) {
    return new Promise((resolve, reject) => {
      get(`ugc/item/${params.id}/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

  ExchangeCredit({}, params){
    return new Promise((resolve, reject) => {
      post(`credit/exchange`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },


  AuthUrl({}, params) {
    return new Promise((resolve, reject) => {
      post('account/oauth/auth_url/', params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
